import type { PortalRole } from '../../app/navigation';

export type WorkCategory = {
  id: string;
  code: string;
  name: string;
  is_system: boolean;
  is_active: boolean;
};

export type WorklogRow = {
  id: string;
  user_id: string;
  user_name: string;
  duration_minutes: number;
  description?: string | null;
  is_billable: boolean;
  worked_at: string;
  billing_status: 'OPEN' | 'APPROVED' | 'CLOSED';
  work_category_id?: string | null;
  category_code?: string | null;
  category_name?: string | null;
  can_edit?: boolean;
  can_delete?: boolean;
};

export type WorklogPayload = {
  rows: WorklogRow[];
  summary: {
    total_minutes: number;
    billable_minutes: number;
  };
  can_create: boolean;
  ticket_status: string;
};

export type WorklogsPanelProps = {
  ticketId: string;
  ticketCategoryId?: string | null;
  role: PortalRole;
  currentUserId: string;
  ticketStatus?: string;
  onChanged?: () => void;
};

const MUTATION_ROLES = new Set<PortalRole>(['ADMIN', 'MANAGER', 'DISPATCHER', 'EXECUTOR']);

export function canCreateWorklog(payload: WorklogPayload | undefined, role: PortalRole) {
  return MUTATION_ROLES.has(role) && payload?.can_create === true;
}

export function canEditWorklog(row: WorklogRow, role: PortalRole, _currentUserId: string) {
  return MUTATION_ROLES.has(role) && row.can_edit === true;
}

export function canDeleteWorklog(row: WorklogRow, role: PortalRole, _currentUserId: string) {
  return MUTATION_ROLES.has(role) && row.can_delete === true;
}

export function defaultWorkCategory(categories: WorkCategory[], ticketCategoryId?: string | null) {
  const active = categories.filter(category => category.is_active);
  return active.find(category => category.id === ticketCategoryId)?.id
    ?? active.find(category => category.code === 'SUPPORT')?.id
    ?? active[0]?.id
    ?? '';
}
